"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var countries = [{
  value: 'AF',
  label: 'Afghanistan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AL',
  label: 'Albania',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'DZ',
  label: 'Algeria',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AS',
  label: 'American Samoa',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AD',
  label: 'Andorra',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AO',
  label: 'Angola',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AI',
  label: 'Anguilla',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AQ',
  label: 'Antarctica',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AG',
  label: 'Antigua and Barbuda',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AR',
  label: 'Argentina',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AM',
  label: 'Armenia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AW',
  label: 'Aruba',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AU',
  label: 'Australia',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'AT',
  label: 'Austria',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'AZ',
  label: 'Azerbaijan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PT-20',
  label: 'Azores',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BS',
  label: 'Bahamas',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BH',
  label: 'Bahrain',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BD',
  label: 'Bangladesh',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BB',
  label: 'Barbados',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BY',
  label: 'Belarus',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BE',
  label: 'Belgium',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'BZ',
  label: 'Belize',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BJ',
  label: 'Benin',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BM',
  label: 'Bermuda',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BT',
  label: 'Bhutan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BO',
  label: 'Bolivia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BA',
  label: 'Bosnia And Herzegowina',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BW',
  label: 'Botswana',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BV',
  label: 'Bouvet Island',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BR',
  label: 'Brazil',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IO',
  label: 'British Indian Ocean Territory',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VG',
  label: 'British Virgin Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BN',
  label: 'Brunei Darussalam',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BG',
  label: 'Bulgaria',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'BF',
  label: 'Burkina Faso',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'BI',
  label: 'Burundi',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KH',
  label: 'Cambodia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CM',
  label: 'Cameroon',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CA',
  label: 'Canada',
  postcodeRequired: true,
  statesOrProvinces: [{
    value: 'AB',
    label: 'Alberta'
  }, {
    value: 'BC',
    label: 'British Columbia'
  }, {
    value: 'MB',
    label: 'Manitoba'
  }, {
    value: 'NB',
    label: 'New Brunswick'
  }, {
    value: 'NL',
    label: 'Newfoundland and Labrador'
  }, {
    value: 'NT',
    label: 'Northwest Territories'
  }, {
    value: 'NS',
    label: 'Nova Scotia'
  }, {
    value: 'NU',
    label: 'Nunavut'
  }, {
    value: 'ON',
    label: 'Ontario'
  }, {
    value: 'PE',
    label: 'Prince Edward Island'
  }, {
    value: 'QC',
    label: 'Quebec'
  }, {
    value: 'SK',
    label: 'Saskatchewan'
  }, {
    value: 'YT',
    label: 'Yukon'
  }],
  postcodeRegex: '^(?:[A-Za-z]\\d[A-Z]\\s\\d[A-Z]\\d)$',
  postcodePlaceholder: 'e.g. X0X 0X0',
  postcodeMaxLength: 7
}, {
  value: 'CV',
  label: 'Cape Verde',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KY',
  label: 'Cayman Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CF',
  label: 'Central African Republic',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TD',
  label: 'Chad',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CL',
  label: 'Chile',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CN',
  label: 'China',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CX',
  label: 'Christmas Island',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CC',
  label: 'Cocos (Keeling) Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CO',
  label: 'Colombia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KM',
  label: 'Comoros',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CG',
  label: 'Congo',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CD',
  label: 'Congo The Democratic Republic',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CK',
  label: 'Cook Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'FR-H',
  label: 'Corsica',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CR',
  label: 'Costa Rica',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CI',
  label: 'Cote d Ivoire (Ivory Coast)',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HR',
  label: 'Croatia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CU',
  label: 'Cuba',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CY',
  label: 'Cyprus',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'CZ',
  label: 'Czech Republic',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{3}\\s\\d{2})$',
  postcodePlaceholder: 'e.g. 000 00',
  postcodeMaxLength: 6
}, {
  value: 'DK',
  label: 'Denmark',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'DJ',
  label: 'Djibouti',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'DM',
  label: 'Dominica',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'DO',
  label: 'Dominican Republic',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'EC',
  label: 'Ecuador',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'EG',
  label: 'Egypt',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SV',
  label: 'El Salvador',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GQ',
  label: 'Equatorial Guinea',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ER',
  label: 'Eritrea',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'EE',
  label: 'Estonia',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'ET',
  label: 'Ethiopia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'FK',
  label: 'Falkland Islands (Malvinas)',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'FO',
  label: 'Faroe Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'FJ',
  label: 'Fiji',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'FI',
  label: 'Finland',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'FR',
  label: 'France (Includes Monaco)',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'FX',
  label: 'France Metropolitan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GF',
  label: 'French Guiana',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PF',
  label: 'French Polynesia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TF',
  label: 'French Southern Territories',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GA',
  label: 'Gabon',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GM',
  label: 'Gambia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GE',
  label: 'Georgia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'DE',
  label: 'Germany',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'FM',
  label: 'Federated States of Micronesia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GH',
  label: 'Ghana',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GI',
  label: 'Gibraltar',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GR',
  label: 'Greece',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{3}\\s\\d{2})$',
  postcodePlaceholder: 'e.g. 000 00',
  postcodeMaxLength: 6
}, {
  value: 'GL',
  label: 'Greenland',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GD',
  label: 'Grenada',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GP',
  label: 'Guadeloupe',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GU',
  label: 'Guam',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GT',
  label: 'Guatemala',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GG',
  label: 'Guernsey',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: /^([G][Y]\d{1,2}\s\d[A-Z]{2})$/i,
  postcodePlaceholder: 'e.g. GY1 1AA',
  postcodeMaxLength: 8
}, {
  value: 'GN',
  label: 'Guinea',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GW',
  label: 'Guinea-Bissau',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GY',
  label: 'Guyana',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HT',
  label: 'Haiti',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HM',
  label: 'Heard And Mc Donald Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HN',
  label: 'Honduras',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HK',
  label: 'Hong Kong',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'HU',
  label: 'Hungary',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'IS',
  label: 'Iceland',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IN',
  label: 'India',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ID',
  label: 'Indonesia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IR',
  label: 'Iran',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IQ',
  label: 'Iraq',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IE',
  label: 'Ireland',
  postcodeRequired: false,
  postcodeRegex: '^$|(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$',
  postcodeMaxLength: 8,
  postcodePlaceholder: 'e.g. D01 X4E6',
  statesOrProvinces: []
}, {
  value: 'IM',
  label: 'Isle of Man',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: /^([I][M]\d{1,2}\s\d[A-Z]{2})$/i,
  postcodePlaceholder: 'e.g. IM0 0ZZ',
  postcodeMaxLength: 8
}, {
  value: 'IL',
  label: 'Israel',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'IT',
  label: 'Italy',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'JM',
  label: 'Jamaica',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'JP',
  label: 'Japan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'JE',
  label: 'Jersey',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: /^([J][E]\d\s\d[A-Z]{2})$/i,
  postcodePlaceholder: 'e.g. JE0 0AA',
  postcodeMaxLength: 8
}, {
  value: 'JO',
  label: 'Jordan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KZ',
  label: 'Kazakhstan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KE',
  label: 'Kenya',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KI',
  label: 'Kiribati',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KP',
  label: 'Korea Democratic People Repub',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KW',
  label: 'Kuwait',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KG',
  label: 'Kyrgyzstan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LA',
  label: 'Laos',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LV',
  label: 'Latvia',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:[L]{1}[V]{1}\\-\\d{4})$',
  postcodePlaceholder: 'e.g. LV-0000',
  postcodeMaxLength: 7
}, {
  value: 'LB',
  label: 'Lebanon',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LS',
  label: 'Lesotho',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LR',
  label: 'Liberia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LY',
  label: 'Libya',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LI',
  label: 'Liechtenstein',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LT',
  label: 'Lithuania',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'LU',
  label: 'Luxembourg',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'MO',
  label: 'Macao',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MK',
  label: 'Macedonia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MG',
  label: 'Madagascar',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MW',
  label: 'Malawi',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MY',
  label: 'Malaysia',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'MV',
  label: 'Maldives',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ML',
  label: 'Mali',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MT',
  label: 'Malta',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:[A-Z]{3}\\s\\d{4})$',
  postcodePlaceholder: 'e.g. XXX 0000',
  postcodeMaxLength: 8
}, {
  value: 'MH',
  label: 'Marshall Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MQ',
  label: 'Martinique',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MR',
  label: 'Mauritania',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MU',
  label: 'Mauritius',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'YT',
  label: 'Mayotte',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MX',
  label: 'Mexico',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MC',
  label: 'Monaco',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MN',
  label: 'Mongolia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ME',
  label: 'Montenegro',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MS',
  label: 'Montserrat',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MA',
  label: 'Morocco',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MZ',
  label: 'Mozambique',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MM',
  label: 'Myanmar (Burma)',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NA',
  label: 'Namibia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NR',
  label: 'Nauru',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NP',
  label: 'Nepal',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NL',
  label: 'Netherlands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AN',
  label: 'Netherlands Antilles',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NC',
  label: 'New Caledonia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NZ',
  label: 'New Zealand',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'NI',
  label: 'Nicaragua',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NE',
  label: 'Niger',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NG',
  label: 'Nigeria',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NU',
  label: 'Niue',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NF',
  label: 'Norfolk Island',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MP',
  label: 'Northern Mariana Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'NO',
  label: 'Norway',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'OM',
  label: 'Oman',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PK',
  label: 'Pakistan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PW',
  label: 'Palau',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PS',
  label: 'Palestinian Territory Occupied',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PA',
  label: 'Panama',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PG',
  label: 'Papua New Guinea',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PY',
  label: 'Paraguay',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PE',
  label: 'Peru',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PH',
  label: 'Philippines',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'PN',
  label: 'Pitcairn',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PL',
  label: 'Poland',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{2}-\\d{3})$',
  postcodePlaceholder: 'e.g. 00-000',
  postcodeMaxLength: 6
}, {
  value: 'PT',
  label: 'Portugal',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4}-\\d{3})$',
  postcodePlaceholder: 'e.g. 0000-000',
  postcodeMaxLength: 8
}, {
  value: 'PR',
  label: 'Puerto Rico',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'QA',
  label: 'Qatar',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'MD',
  label: 'Republic of Moldova',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'RE',
  label: 'Reunion',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'RO',
  label: 'Romania',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{6})$',
  postcodePlaceholder: 'e.g. 000000',
  postcodeMaxLength: 6
}, {
  value: 'RU',
  label: 'Russian Federation',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'RW',
  label: 'Rwanda',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SH',
  label: 'Saint Helena Ascension and Tristan da Cunha',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KN',
  label: 'Saint Kitts And Nevis',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SM',
  label: 'San Marino',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ST',
  label: 'Sao Tome and Principe',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SA',
  label: 'Saudi Arabia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SN',
  label: 'Senegal',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'RS',
  label: 'Serbia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'CS',
  label: 'Serbia and Montenegro',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SC',
  label: 'Seychelles',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SL',
  label: 'Sierra Leone',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SG',
  label: 'Singapore',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{6})$',
  postcodePlaceholder: 'e.g. 000000',
  postcodeMaxLength: 6
}, {
  value: 'SK',
  label: 'Slovak Republic',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{3}\\s\\d{2})$',
  postcodePlaceholder: 'e.g. 000-00',
  postcodeMaxLength: 6
}, {
  value: 'SI',
  label: 'Slovenia',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'SB',
  label: 'Solomon Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SO',
  label: 'Somalia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ZA',
  label: 'South Africa',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'GS',
  label: 'South Georgia And The South Sand',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'KR',
  label: 'South Korea',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'ES',
  label: 'Spain',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000',
  postcodeMaxLength: 5
}, {
  value: 'LK',
  label: 'Sri Lanka',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'LC',
  label: 'St. Lucia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'PM',
  label: 'St. Pierre and Miquelon',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VC',
  label: 'St. Vincent and the Grenadines',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SD',
  label: 'Sudan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SR',
  label: 'Suriname',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SJ',
  label: 'Svalbard And Jan Mayen Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SZ',
  label: 'Swaziland',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'SE',
  label: 'Sweden',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{3}\\s\\d{2})$',
  postcodePlaceholder: 'e.g. 000 00',
  postcodeMaxLength: 6
}, {
  value: 'CH',
  label: 'Switzerland',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^(?:\\d{4})$',
  postcodePlaceholder: 'e.g. 0000',
  postcodeMaxLength: 4
}, {
  value: 'SY',
  label: 'Syria',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TW',
  label: 'Taiwan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TJ',
  label: 'Tajikistan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TZ',
  label: 'Tanzania',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TH',
  label: 'Thailand',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TL',
  label: 'Timor-Leste',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TG',
  label: 'Togo',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TK',
  label: 'Tokelau',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TO',
  label: 'Tonga',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TT',
  label: 'Trinidad and Tobago',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TN',
  label: 'Tunisia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TR',
  label: 'Turkey',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TM',
  label: 'Turkmenistan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TC',
  label: 'Turks and Caicos Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'TV',
  label: 'Tuvalu',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'UG',
  label: 'Uganda',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'UA',
  label: 'Ukraine',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'AE',
  label: 'United Arab Emirates',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'GB',
  label: 'United Kingdom',
  postcodeRequired: true,
  statesOrProvinces: [],
  postcodeRegex: '^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][ABD-HJLNP-UW-Z]{2}$',
  postcodePlaceholder: 'e.g. SW1E 5NN',
  postcodeMaxLength: 8
}, {
  value: 'US',
  label: 'United States',
  postcodeRequired: true,
  statesOrProvinces: [{
    value: 'AL',
    label: 'Alabama'
  }, {
    value: 'AK',
    label: 'Alaska'
  }, {
    value: 'AS',
    label: 'American Samoa'
  }, {
    value: 'AZ',
    label: 'Arizona'
  }, {
    value: 'AR',
    label: 'Arkansas'
  }, {
    value: 'AE',
    label: 'Armed Forces Europe'
  }, {
    value: 'CA',
    label: 'California'
  }, {
    value: 'CO',
    label: 'Colorado'
  }, {
    value: 'CT',
    label: 'Connecticut'
  }, {
    value: 'DE',
    label: 'Delaware'
  }, {
    value: 'DC',
    label: 'District of Columbia'
  }, {
    value: 'FM',
    label: 'Federated States of Micronesia'
  }, {
    value: 'FL',
    label: 'Florida'
  }, {
    value: 'GA',
    label: 'Georgia'
  }, {
    value: 'GU',
    label: 'Guam'
  }, {
    value: 'HI',
    label: 'Hawaii'
  }, {
    value: 'ID',
    label: 'Idaho'
  }, {
    value: 'IL',
    label: 'Illinois'
  }, {
    value: 'IN',
    label: 'Indiana'
  }, {
    value: 'IA',
    label: 'Iowa'
  }, {
    value: 'KS',
    label: 'Kansas'
  }, {
    value: 'KY',
    label: 'Kentucky'
  }, {
    value: 'LA',
    label: 'Louisiana'
  }, {
    value: 'ME',
    label: 'Maine'
  }, {
    value: 'MH',
    label: 'Marshall Islands'
  }, {
    value: 'MD',
    label: 'Maryland'
  }, {
    value: 'MA',
    label: 'Massachusetts'
  }, {
    value: 'MI',
    label: 'Michigan'
  }, {
    value: 'MN',
    label: 'Minnesota'
  }, {
    value: 'MS',
    label: 'Mississippi'
  }, {
    value: 'MO',
    label: 'Missouri'
  }, {
    value: 'MT',
    label: 'Montana'
  }, {
    value: 'NE',
    label: 'Nebraska'
  }, {
    value: 'NV',
    label: 'Nevada'
  }, {
    value: 'NH',
    label: 'New Hampshire'
  }, {
    value: 'NJ',
    label: 'New Jersey'
  }, {
    value: 'NM',
    label: 'New Mexico'
  }, {
    value: 'NY',
    label: 'New York'
  }, {
    value: 'NC',
    label: 'North Carolina'
  }, {
    value: 'ND',
    label: 'North Dakota'
  }, {
    value: 'MP',
    label: 'Northern Mariana Islands'
  }, {
    value: 'OH',
    label: 'Ohio'
  }, {
    value: 'OK',
    label: 'Oklahoma'
  }, {
    value: 'OR',
    label: 'Oregon'
  }, {
    value: 'PW',
    label: 'Palau'
  }, {
    value: 'PA',
    label: 'Pennsylvania'
  }, {
    value: 'PR',
    label: 'Puerto Rico'
  }, {
    value: 'RI',
    label: 'Rhode Island'
  }, {
    value: 'SC',
    label: 'South Carolina'
  }, {
    value: 'SD',
    label: 'South Dakota'
  }, {
    value: 'TN',
    label: 'Tennessee'
  }, {
    value: 'TX',
    label: 'Texas'
  }, {
    value: 'UT',
    label: 'Utah'
  }, {
    value: 'VT',
    label: 'Vermont'
  }, {
    value: 'VI',
    label: 'Virgin Islands'
  }, {
    value: 'VA',
    label: 'Virginia'
  }, {
    value: 'WA',
    label: 'Washington'
  }, {
    value: 'WV',
    label: 'West Virginia'
  }, {
    value: 'WI',
    label: 'Wisconsin'
  }, {
    value: 'WY',
    label: 'Wyoming'
  }],
  postcodeRegex: '^(?:\\d{5}-\\d{4})$|^(?:\\d{5})$',
  postcodePlaceholder: 'e.g. 00000-0000 or 00000',
  postcodeMaxLength: 10
}, {
  value: 'UM',
  label: 'United States Minor Outlying Isl',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'UY',
  label: 'Uruguay',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'UZ',
  label: 'Uzbekistan',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VU',
  label: 'Vanuatu',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VA',
  label: 'Vatican City',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VE',
  label: 'Venezuela',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VN',
  label: 'Vietnam',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'VI',
  label: 'Virgin Islands (U.S.)',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'WF',
  label: 'Wallis and Furuna Islands',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'EH',
  label: 'Western Sahara',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'WS',
  label: 'Western Samoa',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'YE',
  label: 'Yemen',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ZM',
  label: 'Zambia',
  postcodeRequired: false,
  statesOrProvinces: []
}, {
  value: 'ZW',
  label: 'Zimbabwe',
  postcodeRequired: false,
  statesOrProvinces: []
}];
var _default = exports["default"] = countries;